import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../../reducers";
import { useSelector } from "react-redux";
import { common } from "@material-ui/core/colors";
import { Common as UtilCommon } from '../../../utils/Common';

export default function CallerVerifierInfo() {
  const classes = useStyles();

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.formOneWrapper} >
        <Grid item xs={12} sm={12} md={6} lg={4} >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_caller_verifier_name_lbl}
            </span>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {vendorDetail.CallerVerifierName}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_caller_verifier_designation_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {vendorDetail.CallerVerifierDesignation}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_caller_verifier_date_lbl}
            </span>
          </Grid>
          <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {vendorDetail.CallerVerifiedDate ? UtilCommon.getLocalDateTime(vendorDetail.CallerVerifiedDate.toString()) : "" }
            </span>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
